import moment from "moment-timezone";
import React from "react";
import { Style } from "./style";
import { RestViewProps } from "./type";

moment.locale("en");

const RestView = ({ hook }: RestViewProps) => {
  return (
    <Style>
      <div
        className={`knockContainer ${hook.kioskMode && "kiosk"}`}
        onClick={hook.navigateMaster}
      >
        {hook.kioskMode ? (
          <>
            <img
              src={`${process.env.PUBLIC_URL}/knockknock/img/knockMainLogo.png`}
              width={223}
              alt="logo"
            />
            <button className="enterButton">ROOM SERVICE</button>
          </>
        ) : (
          <>
            <div className="header">
              <img src={hook.theme.logo} alt="logo" />
            </div>
            <div className="body">
              <div className="clock" onClick={(e) => e.stopPropagation()}>
                <div className="timeWrap">
                  <h1 className="time">
                    {hook.formattedTime.formattedHour[0]}
                  </h1>
                  <h1 className="time">
                    {hook.formattedTime.formattedHour[1]}
                  </h1>
                  <h1>:</h1>
                  <h1 className="time">{hook.formattedTime.formattedMin[0]}</h1>
                  <h1 className="time">{hook.formattedTime.formattedMin[1]}</h1>
                  <h3>{hook.formattedTime.ampm}</h3>
                </div>
                {hook.isSet ? (
                  <div className="settingWrap">
                    <div className="setting">
                      <div className="buttonWrap volume">
                        <img
                          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_add_grey.svg`}
                          alt="add"
                          onClick={() => hook.addTime("hour")}
                        />
                        <div className="line" />
                        <img
                          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_minus_grey.svg`}
                          alt="minus"
                          onClick={() => hook.subtractTime("hour")}
                        />
                      </div>
                      <h2>
                        {String(
                          hook.hour % 12 === 0 ? 12 : hook.hour % 12
                        ).padStart(2, "0")}
                        :{String(hook.minute).padStart(2, "0")}{" "}
                        <span>{hook.hour > 11 ? "PM" : "AM"}</span>
                      </h2>
                      <div className="buttonWrap volume">
                        <img
                          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_add_grey.svg`}
                          alt="add"
                          onClick={() => hook.addTime("min")}
                        />
                        <div className="line" />
                        <img
                          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_minus_grey.svg`}
                          alt="minus"
                          onClick={() => hook.subtractTime("min")}
                        />
                      </div>
                    </div>
                    <div className="buttonWrap">
                      <button className="confirm" onClick={hook.cancelAlarm}>
                        cancel
                      </button>
                      <button className="confirm ok" onClick={hook.saveAlarm}>
                        OK
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="row">
                    <button onClick={hook.openAlarm}>
                      <img
                        src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_alarm_white.svg`}
                        alt="alarm"
                      />
                      {hook.alarm.time ? (
                        <h4>{moment(hook.alarm.time).format("hh:mm A")}</h4>
                      ) : (
                        <>
                          Morning Call
                          <img
                            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_add_grey.svg`}
                            alt="add"
                          />
                        </>
                      )}
                    </button>
                    {hook.alarm.time && (
                      <button className="delete" onClick={hook.deleteAlarm}>
                        <img
                          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close_grey.svg`}
                          alt="close"
                        />
                      </button>
                    )}
                  </div>
                )}
              </div>
              <button className="dining">
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_dining.svg`}
                  alt="dining"
                />
                ROOM SERVICE
              </button>
            </div>
          </>
        )}
      </div>
    </Style>
  );
};
export default RestView;
